import React from "react";
import { Helmet } from "react-helmet";

import SingleColumnDashView from "dashboard/components/SingleColumnDashView";
import { STATUS, SORT } from "config/constants";

export default function Drafts() {
  return (
    <div>
      <Helmet>
        <title>Drafts</title>
      </Helmet>

      <SingleColumnDashView
        pubStatus={"drafts"}
        defaultSort={SORT.BY_LAST_UPDATED}
        optionsForOrdering={[SORT.BY_LAST_UPDATED, SORT.BY_ETA]}
        optionsForStatusFilter={[
          STATUS.IN_PROGRESS,
          STATUS.READY_FOR_EDITS,
          STATUS.UNASSIGNED,
        ]}
        sortDisabled={true}
      />
    </div>
  );
}
